// Add aria-labels to Fancybox buttons that match the title attribute
function addAriaLabelToToolbarItems(toolbarItemsObj) {
    for (const [key, value] of Object.entries(toolbarItemsObj)) {
        if(typeof value.tpl === 'string') {
            const titleAttributeMatch = value.tpl.match(/title="{{([^"]*)}}"/);

            if (!titleAttributeMatch) continue;

            const [titleAttribute, titleText] = titleAttributeMatch;
            const modifiedButton = value.tpl.replace(titleAttribute, `${titleAttribute} aria-label="{{${titleText}}}"`);
            fancyBoxCustomItems[key] = { tpl: modifiedButton };
        }
    }
}

const fancyBoxDefaultToolbarItems = Fancybox?.Plugins?.Toolbar?.defaults?.items;
const fancyBoxCustomItems = {};

if(typeof fancyBoxDefaultToolbarItems === 'object' && fancyBoxDefaultToolbarItems !== null) {
    addAriaLabelToToolbarItems(fancyBoxDefaultToolbarItems);
}


const calpak = window.calpak

let quickView = false;
let productMeta = false;
let klaviyoLoaded = false;
let product = window.product;

/*if (calpak.current_product_id){
    // console.log('--- pdp calpak:loaded ---')
    // https://collect.js.org/api/where.html
    product = calpak.products.where('id', calpak.current_product_id).first();
    window.product = product
    calpak.setProductData(product, document.querySelector('.pdp__variants'), calpak.current_variant_id);

    // const current_variant = product.variants.filter(variant=>variant.id.toString()==calpak.current_variant_id)[0];
    // const variant_title = calpak.capitalize(calpak.unhandleize(current_variant.title))

    // const title = `${product.title} in ${variant_title} | CALPAK`;
    // const description = `Shop the ${variant_title} -  ${product.title} at CALPAK. Free shipping on US orders $75+.`;

    // document.title = title;

    // const metaDescription = document.querySelector('meta[name="description"]')
    // if(metaDescription) metaDescription.setAttribute("content", description);

    // const ogTitle = document.querySelector('meta[property="og:title"]');
    // if(ogTitle) ogTitle.setAttribute("content", title);

    // const ogDescription = document.querySelector('meta[property="og:description"]');
    // if(ogDescription) ogDescription.setAttribute("content", description);

}*/

function getProductUnitColorMatch(productUnit, color, colorGroup, onlyAvailable = true) {
    let match = false, backupMatch = false;

    const productUnitOptions = productUnit.querySelectorAll('.variant-select option');
    for(let i = 0; i < productUnitOptions.length; i++) {
        let singleOption = productUnitOptions[i];
        const available = singleOption.getAttribute('data-available');
        const optionColor = singleOption.getAttribute('data-option1');

        if(color === optionColor) {
            if(!onlyAvailable || available == 'true') {
                match = singleOption;
                break;
            } else {
                backupMatch = singleOption;
            }
        } else if(match === false && available == 'true' && colorGroup.colors.indexOf(optionColor) > -1) match = singleOption;
    }

    if(match === false && backupMatch !== false) match = backupMatch;

    return match;
}

function matchProductUnitsToOption(productUnits, option, onlyAvailable = true) {
    const color = option.getAttribute('data-option1');
    const colorGroup = calpak.getColorGroup(color);

    productUnits.forEach(productUnit => {
        const match = getProductUnitColorMatch(productUnit, color, colorGroup, onlyAvailable);
        if(match) {
            let newSwatch = productUnit.querySelector(`.color-swatch[data-value="${match.getAttribute('data-option1')}"]`);

            if(newSwatch?.classList.contains('product-option--na')) {
                let posibleNewSwatch = productUnit.querySelector(`.color-swatch[data-available="true"]`);
                if(posibleNewSwatch) newSwatch = posibleNewSwatch;
            }

            const activeFirst = productUnit.querySelector('.color-swatch--first');
            if(activeFirst) activeFirst.classList.remove('color-swatch--first');

            newSwatch?.classList.add('color-swatch--first');
            newSwatch?.click();
        } else {
            const activeFirst = productUnit.querySelector('.color-swatch--first');
            activeFirst?.click();
        }
    });
}

function pdpCreateSizeSelect(variantsizeEl, createTypeSelectProduct, createTypeSelectProductQuickView = false){
    quickView = createTypeSelectProductQuickView;
    product = createTypeSelectProduct;
    const ProductId = variantsizeEl.getAttribute('data-productId');
    const select = variantsizeEl.querySelector('ul.dropdownlist_box');
}

const pdpSizePriceUpdate = async function(option) {
    const selectedColor = option.getAttribute('data-option1');
    const sizeOptions = document.querySelectorAll('.dropdownlist_box li');
    const buttontext = document.querySelector('.dropdown-box');

    for (const sizeOption of sizeOptions) {
      const value = sizeOption.getAttribute('value');
      const productTitle = sizeOption.getAttribute('data-prodtitle');
      try {
        const productInfo = await getProductOptions(value, selectedColor);
        // Update the content of each option with the new product information
        const buttontext = document.querySelector('.dropdown-'+productInfo.producthandle)

        if(typeof productInfo.productavailable !== "undefined"){
            sizeOption.innerHTML = `${productTitle} - Out Of Stock`;
            if(buttontext){
                buttontext.innerHTML = `${productTitle} - Out Of Stock`;
            }
        }else{
            sizeOption.innerHTML = productTitle;
            if(buttontext){
                buttontext.innerHTML = productTitle;
            }
        }
        const producthandle = `${productInfo.title}`;
        sizeOption.setAttribute('data-producthandle', producthandle);
      } catch (error) {
        console.error(error);
      }
    }
}

calpak.pdpSizePriceUpdate = pdpSizePriceUpdate

  async function getProductOptions(handle, selectedColor) {
    // // TODO remove after refactor
    // const productContent = await fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {
    //   method: "GET",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // }).then((res) => {
    //   return res.json();
    // });
    const product = calpak.products.where('handle', handle).first();
    //  const product = calpak.product;
    // console.log('----- product -----', product)
    var defaultVariant = null; // Variable to store the default variant info

    if(product.available){
        for (const variant of product.variants) {
            const originalString = variant.title;
            const separatorIndex = originalString.indexOf(" / ");
            let variantTitle;
            if(separatorIndex >= 0){
                variantTitle = originalString.slice(0, separatorIndex).toLowerCase().replace(/\s+/g, "-");
            }else{
                variantTitle = variant.title.toLowerCase().replace(/\s+/g, "-");
            }
          if (variantTitle === selectedColor && variant.available === true) {
            return {
             producthandle: product.handle,
              title: variantTitle,
              compare_at: formatPrice(variant.compare_at_price / 100),
              price: formatPrice(variant.price / 100),
            };
          } else if (!defaultVariant && variant.available === true) {
            // Store the default variant info if no match found yet
            defaultVariant = {
             producthandle: product.handle,
              title: variantTitle,
              compare_at: formatPrice(variant.compare_at_price / 100),
              price: formatPrice(variant.price / 100),
              available: variant.available
            };
          }
        }

        // If no match found, return the default variant
        if (defaultVariant) {
          return defaultVariant;
        }
    }else{
        return{
            producthandle: product.handle,
            productavailable: product.available,
            compare_at: formatPrice(product.compare_at_price / 100),
            price: formatPrice(product.price / 100),
        }
    }


    throw new Error("Variant not found for the selected color.");
}

const pdpFormSubmitWithSelectorCheck = function (productFormSelector, showCart = true) {
    const productForm = document.querySelector(productFormSelector)

    if (typeof productForm !== undefined && productForm !== null) {
        calpak.pdpFormSubmit(productForm, showCart)

        if (productForm.classList.contains("qv__product")) {
            const qvContainer = document.querySelector(".quick-view__container");
            const previousElement = qvContainer.previousElement;

            document.body.classList.remove("modal-open");
            qvContainer?.classList.remove("quick-view__container--active");

            setTimeout(() => {
                qvContainer?.remove();
                previousElement?.focus();
            }, 305);
        }
    }
}
calpak.pdpFormSubmitWithSelectorCheck = pdpFormSubmitWithSelectorCheck

const pdpFormSubmit = async function pdpFormSubmit(productForm, showCart = true) {
    let email = productForm.querySelector(`input[name="recipient-email"]`)?.value;
    let message = productForm.querySelector(`input[name="recipient-message"]`)?.value;
    let sendOnInput = productForm.querySelector(`input[name="recipient-send-on"]`);
    let sendOn = sendOnInput ? sendOnInput.dataset.formattedDate : false;
    let firstName = productForm.querySelector(`input[name="recipient-first-name"]`)?.value;
    let lastName = productForm.querySelector(`input[name="recipient-last-name"]`)?.value;

    const container = productForm.closest('.pdp__grid, .qv__body');

    if (container.getAttribute('data-status') == 'sold-out') return;

    if (!productForm.dataset.buyNow) {
        productForm.classList.add('shopify-product-form--loading');
    }

    const select = productForm.querySelector('[name="id"]');
    const variant_id = select.value;

    let properties = {};
    if(productForm.dataset.holidayGift == "true"){
      properties["_holiday_gift"] = true
    }


    const selectedAddons = Array.from(productForm.querySelectorAll(".addon-checkbox:checked"))
    .map(checkbox => checkbox.closest(".addon-item"))
    .map(item => {
        return {
            variantId: parseInt(item.dataset.variantId),
            quantity: 1
        };
    });

    if (selectedAddons.length === 0) {
        calpak.addToCart(variant_id, 1, (data) => {
            calpak.updateCart(data);
            // console.log("Added to cart");

            /**
             *  Criteo data layer for GTM
             *  trk_add_to_cart
            */
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "trk_add_to_cart",
                trk: {
                    items: data.items.map((product) => ({
                            id: product.id.toString(),
                            price: parseFloat(product.price) / 100.0,
                            quantity: product.quantity
                        })
                    )
                },
            });
            window.dataLayer.push({
                "rtb_product_id": `${data.items.map((product) => product.id.toString()).join(',')}`
            });

            if (showCart) {
                if (productForm.dataset.buyNow) {
                    window.location.href = "/checkout";
                } else {
                    if (!window.abtestvariant) {
                        window.calpak.openCart();
                    } else {
                        const pdpContainer = document.querySelector(".shopify-product-form");
                        const title = pdpContainer.querySelector(".pdp__title").innerHTML;
                        const color = pdpContainer.querySelector(".pdp__selected-variant").innerHTML;
                        const imgContainer = document.querySelector(".pdp__gallery-container");
                        const img = imgContainer.querySelectorAll(".pdp__media--active")[0].querySelector("img").cloneNode(true);
                        openPopUp(title, color, img);
                    }
                }
            } else {
                productForm.querySelector('.pdp__submit').classList.add('pdp__submit--added');
                setTimeout(() => productForm.querySelector('.pdp__submit').classList.remove('pdp__submit--added'), 2000);
            }
        }, () => {
            productForm.classList.remove('shopify-product-form--loading');
        },
        select.options[select.selectedIndex].hasAttribute('data-final-sale'),
        select.options[select.selectedIndex].hasAttribute('data-true-final-sale'),
        select.options[select.selectedIndex].getAttribute('data-preorder'),
        email,
        message,
        sendOn,
        firstName,
        lastName,
        productForm,
        properties);
    }
    else{
        let variantItems = [];
    
        variantItems.push({variantId: variant_id, quantity: 1});
        variantItems.push(...selectedAddons);
        calpak.addMultiItemsToCart(variantItems, (data) => {
            calpak.updateCart(data);
            // console.log("Added to cart");

            /**
             *  Criteo data layer for GTM
             *  trk_add_to_cart
            */
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "trk_add_to_cart",
                trk: {
                    items: data.items.map((product) => ({
                            id: product.id.toString(),
                            price: parseFloat(product.price) / 100.0,
                            quantity: product.quantity
                        })
                    )
                },
            });
            window.dataLayer.push({
                "rtb_product_id": `${data.items.map((product) => product.id.toString()).join(',')}`
            });

            if (showCart) {
                if (productForm.dataset.buyNow) {
                    window.location.href = "/checkout";
                } else {
                    if (!window.abtestvariant) {
                        window.calpak.openCart();
                    } else {
                        const pdpContainer = document.querySelector(".shopify-product-form");
                        const title = pdpContainer.querySelector(".pdp__title").innerHTML;
                        const color = pdpContainer.querySelector(".pdp__selected-variant").innerHTML;
                        const imgContainer = document.querySelector(".pdp__gallery-container");
                        const img = imgContainer.querySelectorAll(".pdp__media--active")[0].querySelector("img").cloneNode(true);
                        openPopUp(title, color, img);
                    }
                }
            } else {
                productForm.querySelector('.pdp__submit').classList.add('pdp__submit--added');
                setTimeout(() => productForm.querySelector('.pdp__submit').classList.remove('pdp__submit--added'), 2000);
            }
        }, () => {
            productForm.classList.remove('shopify-product-form--loading');
        },
        select.options[select.selectedIndex].hasAttribute('data-final-sale'),
        select.options[select.selectedIndex].hasAttribute('data-true-final-sale'),
        select.options[select.selectedIndex].getAttribute('data-preorder'),
        email,
        message,
        sendOn,
        firstName,
        lastName,
        productForm,
        properties);
    }
    // Ensure the date input retains the selected date after submission
    if (sendOnInput) {
        sendOnInput.value = sendOn;
    }
}
calpak.pdpFormSubmit = pdpFormSubmit;

const updateOptionsAvailability = function(options, select, container) {
    for(let i = 0; i < options.length; i++) {
        const siblingOptions = select.querySelectorAll(`option[data-option${i + 1}="${options[i]}"]`);
        for(let j = 0; j < siblingOptions.length; j++) {
            const option = siblingOptions[j];
            for(let optNum = 0; optNum < options.length; optNum++) {
                if(optNum == i) continue;

                const value = option.getAttribute(`data-option${optNum + 1}`);
                const available = option.getAttribute('data-available');
                const target = container.querySelector(`.pdp__variants [data-position="${optNum + 1}"] [data-value="${value}"]`);

                if(target) {
                    if(available === false || available == 'false') target.classList.add('product-option--na');
                    else target.classList.remove('product-option--na');
                }
            }
        }
    }
}
calpak.updateOptionsAvailability = updateOptionsAvailability

async function triggerWaitlist(waitlistCont) {
    const emailField = waitlistCont.querySelector('.mailing-list-email');
    const email = emailField.value.trim();
    const productForm = waitlistCont.closest('.shopify-product-form');
    const productId = productForm.getAttribute('data-id');

    if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        const variantId = productForm.querySelector('.variant-select').value;

        waitlistCont.classList.remove('pdp__waitlist--error');
        waitlistCont.classList.add('pdp__waitlist--loading');

        //////////////////////// START
        const payload = {
            "data": {
                "type": "back-in-stock-subscription",
                "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": email,
                            }
                        }
                    },
                    "channels": ["EMAIL"],
                },
                "relationships": {
                    "variant": {
                        "data": {
                            "type": "catalog-variant",
                            "id": `$shopify:::$default:::${variantId}`
                        }
                    }
                }
            }
        }

        var requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "revision":"2024-07-15"
            },
            body: JSON.stringify(payload),
        };

        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=M38Kem",requestOptions)
            .then((response) => {
                if(!response.ok) {
                    waitlistCont.classList.add('pdp__waitlist--error');
                    emailField.setAttribute("aria-invalid", "true");
                    emailField.setAttribute("aria-describedby", `waitlist-error--${productId}`);
                } else {
                    waitlistCont.classList.add('pdp__waitlist--success');
                    emailField.setAttribute("aria-invalid", "false");
                    emailField.setAttribute("aria-describedby", `waitlist-success--${productId}`);
                }
            })
            .catch((error) => {
                // console.log('error', error)
                waitlistCont.classList.add('pdp__waitlist--error');
                emailField.setAttribute("aria-invalid", "true");
                emailField.setAttribute("aria-describedby", `waitlist-error--${productId}`);
            })
            .then(() => waitlistCont.classList.remove('pdp__waitlist--loading'));

        const subscriptionOptions = {
            method: 'POST',
            headers: {revision: '2024-07-15', 'content-type': 'application/json'},
            body: JSON.stringify({
                data: {
                    type: 'subscription',
                    attributes: {
                        profile: {data: {type: 'profile', attributes: {email: email}}}
                    },
                    relationships: {list: {data: {type: 'list', id: 'JuPuvw'}}}
                }
            })
        };

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=M38Kem', subscriptionOptions)
            .then(response => {})
            .catch(err => console.error(err));
        //////////////////////////////////// END

    } else {
        waitlistCont.classList.add('pdp__waitlist--error');
        emailField.setAttribute("aria-invalid", "true");
        emailField.setAttribute("aria-describedby", `waitlist-error--${productId}`);
    }
}

const bindWaitlist = function(container) {
    const waitlistCheckboxes = container.querySelectorAll('.mailing-list-checkbox');

    waitlistCheckboxes.forEach(waitlistCheckbox => waitlistCheckbox.addEventListener('click', function() {
        if(this.checked) {
            this.closest('.pdp__waitlist').classList.remove('pdp__waitlist--inactive');
        } else this.closest('.pdp__waitlist').classList.add('pdp__waitlist--inactive');
    }));

    const waitlistSubmitBtns = container.querySelectorAll('.pdp__waitlist-submit');
    waitlistSubmitBtns.forEach(waitlistSubmitBtn => waitlistSubmitBtn.addEventListener('click', async function() {
        const waitlistCont = this.closest('.pdp__waitlist');
        triggerWaitlist(waitlistCont);
    }));

    const waitlistInputs = container.querySelectorAll('.pdp__waitlist input[type="email"]');
    waitlistInputs.forEach(waitlistInput => waitlistInput.addEventListener('keyup', function(event) {
        if (event.defaultPrevented) return;

        if((typeof event.key != 'undefined' && event.key === "Enter") || event.keyCode === 13) {
            event.preventDefault();
            event.stopPropagation();
            const waitlistCont = this.closest('.pdp__waitlist');
            triggerWaitlist(waitlistCont);
        }
    }));
}
calpak.bindWaitlist = bindWaitlist

document.addEventListener("calpak:loaded", () => {
    const pdpGrid = document.querySelector('.pdp__grid');

    let pdpSwatchesCheckThrottle = false;
    const pdpSwatches = document.querySelectorAll('.pdp__swatches');
    window.addEventListener("resize", checkPDPSwatches);
    function checkPDPSwatches() {
        if(pdpSwatchesCheckThrottle !== false) clearTimeout(pdpSwatchesCheckThrottle);

        pdpSwatchesCheckThrottle = setTimeout(() => {
            pdpSwatches.forEach(pdpSwatch => {
                pdpSwatch.style.setProperty('--max-fit', Math.floor(pdpSwatch.offsetWidth / 28));
            });
        }, 20);
    }
    checkPDPSwatches();




    if(pdpGrid) {
        let variantsizeEl = document.querySelector('.pdp__variant-size');
        if(variantsizeEl) pdpCreateSizeSelect(variantsizeEl, product, quickView);

        const pdpSubmitSection = document.querySelector('.pdp__submit-container');
        const floatingPDPSubmit = document.querySelector('.pdp__floating-submit');
        const attentiveOverlay = document.querySelector('#attentive_overlay');
        const signUpSection = document.querySelector('.shopify-section--contact-form');

        if (typeof floatingPDPSubmit != 'undefined' && floatingPDPSubmit && pdpSubmitSection) {
            let lastScrollTop = window.scrollY;

            const handleScroll = function() {
                const currentScrollTop = window.scrollY;
                const submitRect = pdpSubmitSection.getBoundingClientRect();
                const signUpRect = signUpSection ? signUpSection.getBoundingClientRect() : null;
                const windowHeight = window.innerHeight;

                const isMainSubmitScrolledPast = submitRect.bottom < 0;
                const isSignUpVisible = signUpRect ? (signUpRect.top < windowHeight) : false;
                
                const isScrollingUp = currentScrollTop < lastScrollTop;

                if (isMainSubmitScrolledPast && isScrollingUp && !isSignUpVisible) {
                    floatingPDPSubmit.classList.add('pdp__floating-submit--active');
                    floatingPDPSubmit.classList.remove('display-none');
                    if (typeof attentiveOverlay != "undefined" && attentiveOverlay != null) {
                        attentiveOverlay.classList.add('attentiveOverlay--disabled');
                    }
                } else {
                    floatingPDPSubmit.classList.remove('pdp__floating-submit--active');
                    if (typeof attentiveOverlay != "undefined" && attentiveOverlay != null) {
                        attentiveOverlay.classList.remove('attentiveOverlay--disabled');
                    }

                    if (isSignUpVisible) {
                        floatingPDPSubmit.classList.add('display-none');
                    } else {
                         floatingPDPSubmit.classList.remove('display-none');
                    }
                }
                
                lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
            };

            window.addEventListener('scroll', handleScroll, { passive: true });
            handleScroll(); // Initial check
        }

        const select = pdpGrid.querySelector('.variant-select');
        setupGalleryMediaLimit(pdpGrid.querySelectorAll('.pdp__media--active, .pdp__media--first-prod-video, .pdp__media--second-prod-video, .pdp__media--var-video'));
        // pdpGalleryUpdate(pdpGrid, select.options[select.selectedIndex], false);

        const featuredCollectionProducts = document.querySelectorAll('.shopify-section--pdp-featured .product-unit');
        featuredCollectionProducts.forEach(featuredCollectionProduct => featuredCollectionProduct.setAttribute('data-init-1', select.options[select.selectedIndex].getAttribute('data-option1')));

        updateOptionsAvailability(getProductOptionsList(pdpGrid), select, pdpGrid);

        let galleryMoreBtn = document.querySelector('.pdp-gallery__more-btn');
        if(galleryMoreBtn) galleryMoreBtn.addEventListener('click', function(e) {
            e.preventDefault();
            const cont = this.closest('.pdp__gallery-container');
            if(cont) cont.classList.add('pdp__gallery-container--expanded');
            const wideMedia = cont.querySelectorAll('.pdp__media--wide');
            if(wideMedia.length > 1) for(let i = 1; i < wideMedia.length; i++) wideMedia[i].classList.remove('pdp__media--wide');
            const allMedia = cont.querySelectorAll('.pdp__media.pdp__media--active');
            if(allMedia.length % 2 == 0) {
                allMedia[allMedia.length - 1].classList.add('pdp__media--wide');
            }
        });

        const allMediaZoom = document.querySelectorAll('.pdp__media .img-zoom');
        allMediaZoom.forEach(media => media.addEventListener('mousemove', function(e) {
            let left = 0;
            let top = 0;

            if(this.closest('.pdp__media').classList.contains('pdp__media--wide')) {
                top = (e.offsetY / this.offsetHeight) * -66.66;
                left = (e.offsetX / this.offsetWidth) * -33.33;
            } else {
                top = (e.offsetY / this.offsetHeight) * -50;
                left = (e.offsetX / this.offsetWidth) * -50;
            }

            this.style.transform = `translate3d(${left}%, ${top}%, 0)`;
        }));

        const productForm = document.querySelector('.shopify-product-form');
        if(productForm) productForm.addEventListener('submit', async function(e) {
            e.preventDefault();
            const firstName = productForm.querySelector("input[name='recipient-first-name']");
            const email = productForm.querySelector("input[name='recipient-email']");
            const recipientCheckbox = document.getElementById(`recipient-checkbox`);

                if(recipientCheckbox.checked && email && firstName){
                    if(email.value !== "" && firstName.value !== ""){
                        e.preventDefault();
                        calpak.pdpFormSubmit(productForm, true);
                    }
                } else {
                    e.preventDefault();
                    calpak.pdpFormSubmit(productForm, true);
                }
        });

        bindWaitlist(pdpGrid);
    }
    // ADA custom radio JS solution
        let colorButtonsPdp = document.querySelectorAll('.pdp__info .color-swatch');
        let swatchesKeyContainerPdp = document.querySelectorAll('.pdp__info .pdp__swatches-group > .pdp__swatches');
        function customRadioButtons(){


            [].map.call(colorButtonsPdp, (colorButton) => {
            colorButton.addEventListener('click', function(e) {
                selectColorButton(e.target);
                });
            });


        [].map.call(swatchesKeyContainerPdp, (container => {
            container.addEventListener('keyup', function(e) {
                switch(e.key) {
                    case 'ArrowUp':
                    case 'ArrowLeft':
                    selectPreviousColorButton(e.target);
                    break;

                    case 'ArrowDown':
                    case 'ArrowRight':
                    selectNextColorButton(e.target);
                    break;

                    case ' ':
                    selectColorButton(e.target);
                    break;
                }
                });
        }));

        const waitlistInputs = document.querySelectorAll('.pdp__waitlist input[type="email"]');
        waitlistInputs.forEach(waitlistInput => waitlistInput.addEventListener('keyup', function(event) {
            if (event.defaultPrevented) return;

            if((typeof event.key != 'undefined' && event.key === "Enter") || event.keyCode === 13) {
                event.preventDefault();
                event.stopPropagation();
                const waitlistCont = this.closest('.pdp__waitlist');
                triggerWaitlist(waitlistCont);
            }
        }));
    }

    // remove unnecessary aria-label
    const tolstoyVideoTitle = document.querySelector('.tolstoy-stories-title');
    tolstoyVideoTitle && tolstoyVideoTitle.removeAttribute("aria-label");

    // ada color swatches
    let allColorButtons = [];

    pdpSwatches?.forEach((swatchesContainer) => {
        const colorButtons = Array.from(swatchesContainer.querySelectorAll('.color-swatch'));
        allColorButtons = allColorButtons.concat(colorButtons);

        colorButtons.forEach(function (colorButton) {
            colorButton.setAttribute(
              "tabindex",
              colorButton.classList.contains("color-swatch--active")
                ? "0"
                : "-1"
            );
            colorButton.setAttribute(
              "aria-checked",
              colorButton.classList.contains("color-swatch--active")
                ? "true"
                : "false"
            );

            colorButton.addEventListener('click', function (e) {
                e.preventDefault();
            });

            colorButton.addEventListener('keydown', function (e) {
                if (e.key === " " || e.code === "Space" || e.keyCode === 32) {
                    e.stopPropagation();
                    e.preventDefault();
                    e.target.click();
                }

                const key = e.key;

                if (key === 'ArrowRight' || key === 'ArrowUp') {
                    e.preventDefault();
                    e.stopPropagation();
                    focusNextSwatch(allColorButtons.indexOf(colorButton));
                } else if (key === 'ArrowLeft' || key === 'ArrowDown') {
                    e.preventDefault();
                    e.stopPropagation();
                    focusPreviousSwatch(allColorButtons.indexOf(colorButton));
                }
            });

            colorButton.addEventListener('focus', function () {
                selectedColorButton(colorButton);
            });
        });

        function focusNextSwatch(index) {
            if (index < allColorButtons.length - 1) {
                allColorButtons[index + 1].focus();
                allColorButtons[index + 1].click();
            } else {
                allColorButtons[0].focus();
                allColorButtons[0].click();
            }
        }

        function focusPreviousSwatch(index) {
            if (index > 0) {
                allColorButtons[index - 1].focus();
                allColorButtons[index - 1].click();
            } else {
                allColorButtons[allColorButtons.length - 1].focus();
                allColorButtons[allColorButtons.length - 1].click();
            }
        }

        function selectedColorButton(button) {
            allColorButtons.forEach(colorButton => {
                if (colorButton === button) {
                    colorButton.setAttribute("tabindex", "0");
                    colorButton.setAttribute('aria-checked', 'true');
                } else {
                    colorButton.setAttribute("tabindex", "-1");
                    colorButton.setAttribute('aria-checked', 'false');
                }
            });
        }
    });
});

function setupGalleryMediaLimit(newMedia) {
    let mediaLimit = 0;
    if(typeof pdpSettings != 'undefined') {
        const galleryMoreBtn = document.querySelector('.pdp-gallery__more-btn');
        if (!galleryMoreBtn) return;
        mediaLimit = pdpSettings.gallery_limit;

        if(mediaLimit < newMedia.length) {
            galleryMoreBtn.classList.add('pdp-gallery__more-btn--active');

            if(pdpSettings.reapply_limit) {
                document.querySelector('.pdp-gallery__more-btn .img-num').innerHTML = newMedia.length - mediaLimit;

                let expandedCont = document.querySelector('.pdp__gallery-container--expanded');
                if(expandedCont) expandedCont.classList.remove('pdp__gallery-container--expanded');
            }
        } else galleryMoreBtn.classList.remove('pdp-gallery__more-btn--active');
    }

    return mediaLimit;
}

calpak.pdpGalleryControlInfo = {
    isFuncAttached : false,
    currentIndex : 0,
    isTransitioning : false,
    touchStartX : 0,
    currentTranslate : 0,
    prevTranslate : 0,
    animationID: "",
    isDragging : false
}

async function fetchVariantGalleryMarkup(pdpGrid, option) {
    const sectionId = pdpGrid?.getAttribute('section-id');
    if (!sectionId) return null;

    const handleFromForm = pdpGrid.querySelector('form[data-handle]')?.getAttribute('data-handle');
    const handle = handleFromForm || window?.product?.handle || window?.calpak?.product?.handle;
    if (!handle) return null;

    const params = new URLSearchParams({ section_id: sectionId });
    const variantId = option?.value || option?.getAttribute('value');
    if (variantId) params.set('variant', variantId);

    const root = window?.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    const requestUrl = `${normalizedRoot}products/${encodeURIComponent(handle)}?${params.toString()}`;

    // Build a cache key using product handle + color (data-option1) or variant id for uniqueness
    const cacheColor = option?.getAttribute('data-option1') || option?.getAttribute('data-color') || variantId || '';
    const cacheKey = `pdp_gallery_fragments::${handle}::${cacheColor}`;

    // Try to return cached fragments from sessionStorage first
    try {
        const cached = sessionStorage.getItem(cacheKey);
        if (cached) {
            const parsed = JSON.parse(cached);
            const fragments = {};
            const parser = new DOMParser();
            Object.keys(parsed).forEach(selector => {
                const htmlString = parsed[selector];
                if (!htmlString) return;
                const doc = parser.parseFromString(htmlString, 'text/html');
                const node = doc.querySelector(selector) || doc.body.firstElementChild;
                if (node) fragments[selector] = node;
            });

            if (Object.keys(fragments).length) return fragments;
        }
    } catch (err) {
        // Ignore cache parse errors and fall back to network
        console.warn('pdp gallery cache read failed', err);
    }

    try {
        pdpGrid.querySelector('.pdp__gallery-container').classList.add('pdp__gallery-container--loading');
        const response = await fetch(requestUrl, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) {
            window.location.reload();
            throw new Error(`Request failed with status ${response.status}`);
        }

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const selectors = [
            '.pdp__gallery',
            '.pdp__gallery-thumbs',
            '.pdp-gallery-slider-wrapper',
        ];

        const fragments = {};
        const cacheToStore = {};
        selectors.forEach(selector => {
            const fragment = doc.querySelector(selector);
            if (fragment) {
                fragments[selector] = fragment;
                // Store outerHTML for cache (stringify minimal HTML)
                cacheToStore[selector] = fragment.outerHTML;
            }
        });

        // Save to sessionStorage for subsequent requests; ignore storage errors
        try {
            if (Object.keys(cacheToStore).length) sessionStorage.setItem(cacheKey, JSON.stringify(cacheToStore));
        } catch (err) {
            console.warn('Failed to write pdp gallery cache', err);
        }

        pdpGrid.querySelector('.pdp__gallery-container').classList.remove('pdp__gallery-container--loading');
        return Object.keys(fragments).length ? fragments : null;
    } catch (error) {
        console.error('Failed to fetch PDP gallery markup', error);
        return null;
    }
}

const pdpGalleryUpdate = async function (pdpGrid, option, isQuickView) {
    let variantsizeEl = document.querySelector('.pdp__variant-size');
    if (variantsizeEl) pdpCreateSizeSelect(variantsizeEl, product, quickView);

    let pdpGallery = pdpGrid.querySelector('.pdp__gallery, .qv__gallery');
    let pdpThumbs = pdpGrid.querySelector('.pdp__gallery-thumbs, .qv__gallery-thumbs');
    let pdpGalleryInfo = pdpGrid.querySelector('.pdp__media--first-prod-video .pdp__video-info');

    let fetchedFragments = null;
    if (!isQuickView && pdpGallery) {
        fetchedFragments = await fetchVariantGalleryMarkup(pdpGrid, option);
        if (fetchedFragments) {
            const replaceFragment = (selector, existingNode) => {
                const fragment = fetchedFragments[selector];
                if (!fragment) return existingNode;
                const clone = fragment.cloneNode(true);
                if (existingNode) {
                    existingNode.replaceWith(clone);
                } else {
                    const galleryContainer = pdpGrid.querySelector('.pdp__gallery-container') || pdpGrid;
                    galleryContainer.appendChild(clone);
                }
                return clone;
            };

            pdpGallery = replaceFragment('.pdp__gallery', pdpGallery);
            replaceFragment('.pdp-gallery-slider-wrapper', pdpGrid.querySelector('.pdp-gallery-slider-wrapper'));
            replaceFragment('.pdp-gallery__more-btn', pdpGrid.querySelector('.pdp-gallery__more-btn'));

            pdpGallery = pdpGrid.querySelector('.pdp__gallery, .qv__gallery');
            pdpGalleryInfo = pdpGrid.querySelector('.pdp__media--first-prod-video .pdp__video-info');
            setTimeout(() => {
                initFancyboxVariantGalleries();
            }, 100);
        }
    }

    if (!pdpGallery) return;

    let pdpSlides = pdpGallery;
    let pdpThumbSlides = pdpThumbs;
    if (isQuickView) {
        pdpSlides = pdpGallery.querySelector('.qv__gallery-inner') || pdpSlides;
        pdpThumbSlides = pdpThumbs.querySelector('.qv__gallery-thumbs-inner');
    }

    let pdpVideoOrder = false;
    if (pdpGallery.hasAttribute('data-video-order')) pdpVideoOrder = pdpGallery.getAttribute('data-video-order');
    let pdpSecondVideoOrder = false;
    if (pdpGallery.hasAttribute('data-second-video-order')) pdpSecondVideoOrder = pdpGallery.getAttribute('data-second-video-order');

    if(pdpThumbs){
        const allThumbs = pdpThumbs.querySelectorAll('.pdp__media-thumb');
        allThumbs.forEach(mediaActive => mediaActive.classList.remove('pdp__media--active', 'slide'));
    }

    const experiment = window?.igData?.user?.getTestGroup('31fbaa32-0d5e-42f8-a52d-85880ea55706');
    const {name} = experiment ?? {};

    if (experiment) {
        switch (name) {
            case 'Original':
                if (pdpSlides?.querySelector(".pdp__media--second-prod-video"))
                    pdpSlides.querySelector(".pdp__media--second-prod-video").remove();
                break;
            case 'VersionB':

                break;
            default:
                break;
        }
    }

    const usingFetchedMarkup = Boolean(fetchedFragments);
    const allMedia = pdpGallery.querySelectorAll('.pdp__media');

    let newMedia = [];
    let newMediaThumbs = [];

    if (usingFetchedMarkup) {
        newMedia = pdpGallery.querySelectorAll('.pdp__media--active, .pdp__media--first-prod-video, .pdp__media--second-prod-video, .pdp__media--var-video');
    } else {
        allMedia.forEach(mediaActive => mediaActive.classList.remove('pdp__media--active', 'pdp__media--wide', 'pdp__media--extra', 'slide'));

        let currentVariant = null;
        if (pdpGallery.classList.contains('pdp__gallery--old')) {
            let sku = option.getAttribute('data-sku');
            let color = option.getAttribute('data-option1');
            newMedia = pdpGallery.querySelectorAll(`.pdp__media[data-variants=""],.pdp__media[data-variants~="${sku}"],.pdp__media[data-variants~="${color}"]`);
            newMediaThumbs = pdpThumbs.querySelectorAll(`.pdp__media-thumb[data-variants=""],.pdp__media-thumb[data-variants~="${sku}"],.pdp__media-thumb[data-variants~="${color}"]`);
            if(calpak.product)
                calpak.product.variants.forEach(variant => {
                    if (variant.sku.toLowerCase() === sku) {
                        currentVariant = variant;
                    }
                });
        } else {
            newMedia = pdpGallery.querySelectorAll(`.pdp__media[data-id=""],.pdp__media[data-id="${option.value}"]`);
            newMediaThumbs = pdpThumbs.querySelectorAll(`.pdp__media-thumb[data-id=""],.pdp__media-thumb[data-id="${option.value}"]`);
        }
    }

    if (pdpGalleryInfo) {
        if (option.hasAttribute('data-video-info')) {
            const videoInfo = option.getAttribute('data-video-info');
            if (videoInfo) pdpGalleryInfo.innerHTML = videoInfo;
            else pdpGalleryInfo.innerHTML = '';
        } else pdpGalleryInfo.innerHTML = '';
    }

    if (newMedia.length > 0) {
        let mediaVarVideo = false;
        let mediaProdVideo = false;
        let secondMediaProdVideo = false;

        for (let i = 0; i < newMedia.length; i++) {
            let newMed = newMedia[i];

            if (newMed.classList.contains('pdp__media--first-prod-video')) {
                mediaProdVideo = newMed;
            }
            if (newMed.classList.contains('pdp__media--second-prod-video')) {
                secondMediaProdVideo = newMed;
            }
            if (newMed.classList.contains('pdp__media--var-video')) mediaVarVideo = newMed;

            newMed.classList.add('pdp__media--active', 'slide');
            
        }

        let filteredNewMedia = [...newMedia].filter(media => {
            if (media == mediaProdVideo || media == secondMediaProdVideo)
                return false;
            return true;
        })

        if (mediaProdVideo !== false) {
            pdpSlides.insertBefore(mediaProdVideo, filteredNewMedia[pdpVideoOrder - 1]);
        }
        if (secondMediaProdVideo !== false) {
            pdpSlides.insertBefore(secondMediaProdVideo, filteredNewMedia[pdpSecondVideoOrder - 1]);
        }

        if (mediaVarVideo !== false) {
            mediaVarVideo.classList.add('pdp__media--active', 'slide');
        }
        pdpGallery.scrollLeft = 0;

        let activeMedia = pdpGallery.querySelectorAll('.pdp__media--active');
        activeMedia[0].classList.add('pdp__media--wide');

        // Start pdpFloting Dinamic Image
        const currentFirstImageSrc = document.querySelector('.pdp__gallery .pdp__media--wide img')?.src
        const pdpFlotingImage = document.querySelector('.pdp2__floating--image img')
        if (currentFirstImageSrc && pdpFlotingImage) {
            pdpFlotingImage.src = currentFirstImageSrc.replace("width=800", "width=120");
        }
        // End pdpFloting Dinamic Image
        if (!isQuickView) {
            let mediaLimit = setupGalleryMediaLimit(newMedia);
            if (mediaLimit && mediaLimit > 0) {
                for (let i = 0; i < activeMedia.length; i++) {
                    if (mediaLimit % 2 === 0 && i == mediaLimit - 1) activeMedia[i].classList.add('pdp__media--wide');
                    else if (i >= mediaLimit) activeMedia[i].classList.add('pdp__media--extra');
                }
            }
        }
    }

    // Set aria labels for gallery slides
    allMedia.forEach(media => {
        media.removeAttribute('aria-label');
        media.removeAttribute('role');
    });

    if (newMediaThumbs.length > 0) {
        let mediaVarVideo = false;
        let mediaProdVideo = false;
        let secondMediaProdVideo = false;

        const selected = pdpThumbs.querySelector('.slide--selected');
        if (selected) selected.classList.remove('slide--selected');

        for (let i = 0; i < newMediaThumbs.length; i++) {
            let newMed = newMediaThumbs[i];

            if (newMed.classList.contains('pdp__media--first-prod-video')) {
                mediaProdVideo = newMed;
            }
            if (newMed.classList.contains('pdp__media--second-prod-video')) {
                secondMediaProdVideo = newMed;
            }
            if (newMed.classList.contains('pdp__media--var-video')) mediaVarVideo = newMed;

            newMed.classList.add('pdp__media--active', 'slide');
        }

        pdpThumbs.scrollLeft = 0;
        const firstActive = pdpThumbs.querySelector('.pdp__media--active');
        if (firstActive) firstActive.classList.add('slide--selected');

        let filteredNewMediaThumbs = [...newMediaThumbs].filter(media => {
            if (media == mediaProdVideo || media == secondMediaProdVideo)
                return false;
            return true;
        })

        if (mediaVarVideo !== false) {
            mediaVarVideo.classList.add('pdp__media--active', 'slide');
        }

        if (mediaProdVideo !== false) {
            pdpThumbSlides.insertBefore(mediaProdVideo, filteredNewMediaThumbs[pdpVideoOrder - 1]);
        }
        if (secondMediaProdVideo !== false) {
            pdpThumbSlides.insertBefore(secondMediaProdVideo, filteredNewMediaThumbs[pdpSecondVideoOrder - 1]);
        }

        calpak.checkSlider(pdpThumbs.querySelector('.slider'));
    }

    // ALSO UPDATE NEW DESKTOP GALLERY CLASSES (pdp-thumb-* prefix) - DESKTOP ONLY
    const isMobileViewport = window.innerWidth <= 900;
    if (!isMobileViewport) {
        const allNewThumbs = pdpGrid.querySelectorAll('.pdp-thumb-media-thumb');
        const allNewMedia = pdpGrid.querySelectorAll('.pdp-thumb-media');

        let newGalleryMedia = [];
        let newGalleryThumbs = [];

        if (usingFetchedMarkup) {
            newGalleryMedia = pdpGrid.querySelectorAll('.pdp-thumb-media--active, .pdp-thumb-media--first-prod-video, .pdp-thumb-media--second-prod-video, .pdp-thumb-media--var-video');
            newGalleryThumbs = pdpGrid.querySelectorAll('.pdp-thumb-media-thumb.pdp-thumb-media--active, .pdp-thumb-media-thumb.pdp-thumb-media--first-prod-video, .pdp-thumb-media-thumb.pdp-thumb-media--second-prod-video, .pdp-thumb-media-thumb.pdp-thumb-media--var-video');
        } else {
            // Reset all new gallery thumbnail and media classes
            allNewThumbs.forEach(thumb => thumb.classList.remove('pdp-thumb-media--active', 'slide'));
            allNewMedia.forEach(media => media.classList.remove('pdp-thumb-media--active', 'pdp-thumb-media--wide', 'pdp-thumb-media--extra', 'slide'));

            // Set new gallery classes based on same variant selection logic
            if (pdpGallery.classList.contains('pdp__gallery--old')) {
                let sku = option.getAttribute('data-sku');
                let color = option.getAttribute('data-option1');
                newGalleryMedia = pdpGrid.querySelectorAll(`.pdp-thumb-media[data-variants=""],.pdp-thumb-media[data-variants~="${sku}"],.pdp-thumb-media[data-variants~="${color}"]`);
                newGalleryThumbs = pdpGrid.querySelectorAll(`.pdp-thumb-media-thumb[data-variants=""],.pdp-thumb-media-thumb[data-variants~="${sku}"],.pdp-thumb-media-thumb[data-variants~="${color}"]`);
            } else {
                newGalleryMedia = pdpGrid.querySelectorAll(`.pdp-thumb-media[data-id=""],.pdp-thumb-media[data-id="${option.value}"]`);
                newGalleryThumbs = pdpGrid.querySelectorAll(`.pdp-thumb-media-thumb[data-id=""],.pdp-thumb-media-thumb[data-id="${option.value}"]`);
            }
        }

    // Apply active classes and handle video ordering for new gallery (same as old gallery)
    if (newGalleryMedia.length > 0) {
        let newGalleryVarVideo = false;
        let newGalleryProdVideo = false;
        let newGallerySecondProdVideo = false;

        // Identify videos in new gallery media
        for (let i = 0; i < newGalleryMedia.length; i++) {
            let newMed = newGalleryMedia[i];

            if (newMed.classList.contains('pdp-thumb-media--first-prod-video')) {
                newGalleryProdVideo = newMed;
            }
            if (newMed.classList.contains('pdp-thumb-media--second-prod-video')) {
                newGallerySecondProdVideo = newMed;
            }
            if (newMed.classList.contains('pdp-thumb-media--var-video')) newGalleryVarVideo = newMed;

            newMed.classList.add('pdp-thumb-media--active', 'slide');
        }

        // Get container for video repositioning (new gallery main wrapper)
        const newGalleryContainer = pdpGrid.querySelector('.pdp-gallery-thumbnails__main-wrapper');
        
        if (newGalleryContainer) {
            // Filter out videos from regular media for positioning reference
            let filteredNewGalleryMedia = [...newGalleryMedia].filter(media => {
                if (media == newGalleryProdVideo || media == newGallerySecondProdVideo)
                    return false;
                return true;
            });

            // Reposition videos using same logic as old gallery
            if (newGalleryProdVideo !== false && pdpVideoOrder && pdpVideoOrder > 0) {
                const targetPosition = Math.min(pdpVideoOrder - 1, filteredNewGalleryMedia.length - 1);
                if (filteredNewGalleryMedia[targetPosition]) {
                    newGalleryContainer.insertBefore(newGalleryProdVideo, filteredNewGalleryMedia[targetPosition]);
                } else if (filteredNewGalleryMedia.length > 0) {
                    newGalleryContainer.appendChild(newGalleryProdVideo);
                }
            }
            if (newGallerySecondProdVideo !== false && pdpSecondVideoOrder && pdpSecondVideoOrder > 1) {
                const targetPosition = Math.min(pdpSecondVideoOrder - 1, filteredNewGalleryMedia.length - 1);
                if (filteredNewGalleryMedia[targetPosition]) {
                    newGalleryContainer.insertBefore(newGallerySecondProdVideo, filteredNewGalleryMedia[targetPosition]);
                } else if (filteredNewGalleryMedia.length > 0) {
                    newGalleryContainer.appendChild(newGallerySecondProdVideo);
                }
            }
        }

        // Set first as wide (main display) - check DOM order after repositioning
        const activeNewMediaAfterReposition = pdpGrid.querySelectorAll('.pdp-thumb-media--active');
        if (activeNewMediaAfterReposition.length > 0) {
            activeNewMediaAfterReposition[0].classList.add('pdp-thumb-media--wide');
        }
    }
    
    if (newGalleryThumbs.length > 0) {
        // Identify videos in new gallery thumbnails
        const videos = identifyVideoElements(newGalleryThumbs, 'pdp-thumb-media');

        // Get container for thumbnail video repositioning
        const newGalleryThumbsContainer = pdpGrid.querySelector('.pdp-gallery-thumbnails__thumbs-track');
        
        // Reposition videos using extracted helper function
        repositionVideos(videos, newGalleryThumbsContainer, newGalleryThumbs, pdpVideoOrder, pdpSecondVideoOrder);
    } 
    }// End of desktop-only new gallery updates


    const sliderWrapper = document.querySelector(".pdp-gallery-slider-wrapper");
    if (!sliderWrapper) return;

    const currentSlides = sliderWrapper.querySelectorAll(".pdp__media");
    currentSlides.forEach((image) => {
        let medias = pdpSlides.querySelectorAll(".pdp__media.pdp__media--active");
        if (image.classList.contains("pdp__media--prod-video") && !image.classList.contains("pdp__media--second-prod-video")) {
            const pos = image.dataset.videoOrder
            pdpSlides.insertBefore(image, medias[pos - 1]);
        } else if (image.classList.contains("pdp__media--prod-video") && image.classList.contains("pdp__media--second-prod-video")) {
            const pos = image.dataset.videoOrder
            pdpSlides.insertBefore(image, medias[pos - 1]);
        }
    });

    const currentMediaPerVariant = pdpGallery.querySelectorAll('.pdp__media--active');

    const isMobileDevice = window.innerWidth < 900;

    if(isMobileDevice || isQuickView) {
        currentMediaPerVariant.forEach((media, index) => {
            media.setAttribute('aria-label', `Slide ${index + 1} of ${currentMediaPerVariant.length}`);
            media.setAttribute('role', 'group');
        });
        pdpGallery.setAttribute('aria-label', 'Product Images Carousel');
    }

    // This helps to create a loopable slider on mobile by duplicating the first and last slides
    // if (isMobileDevice && !isQuickView) {
    //     // Remove existing duplicate slides
    //     const parent = currentMediaPerVariant[0]?.parentElement;
    //     if (parent) {
    //         parent.querySelectorAll('.duplicate-slide').forEach(node => node.remove());
    //     }

    //     if (currentMediaPerVariant.length <= 2) {
    //         // We don't need to duplicate the slides if there are 2 or less
    //         return;
    //     }
        
    //     // Insert last item before the first one
    //     const lastClone = currentMediaPerVariant[currentMediaPerVariant.length - 1].cloneNode(true);
    //     // Remove data-fancybox attributes from children in lastClone
    //     lastClone.querySelectorAll('[data-fancybox], [data-fancybox-temp]').forEach(el => {
    //         el.removeAttribute('data-fancybox');
    //         el.removeAttribute('data-fancybox-temp');
    //     });
    //     lastClone.classList.add('duplicate-slide');
    //     lastClone.setAttribute('duplicate-slide-index', currentMediaPerVariant.length);
    //     currentMediaPerVariant[0].parentElement.insertBefore(lastClone, currentMediaPerVariant[0]);

    //     // Insert first item right after the last active media slide
    //     const firstClone = currentMediaPerVariant[0].cloneNode(true);
    //     // Remove data-fancybox attributes from children in firstClone
    //     firstClone.querySelectorAll('[data-fancybox], [data-fancybox-temp]').forEach(el => {
    //         el.removeAttribute('data-fancybox');
    //         el.removeAttribute('data-fancybox-temp');
    //     });
    //     firstClone.classList.add('duplicate-slide');
    //     firstClone.setAttribute('duplicate-slide-index', '1');
    //     const lastActive = currentMediaPerVariant[currentMediaPerVariant.length - 1];
    //     lastActive.parentElement.insertBefore(firstClone, lastActive.nextSibling);

    //     // Ensure we are not showing the duplicate as the first slide
    //     const slideParent = currentMediaPerVariant[0]?.parentElement;
    //     if (slideParent) {
    //         const firstRealSlide = slideParent.querySelector('.pdp__media--active.duplicate-slide');
    //         if (firstRealSlide) {
    //             slideParent.scrollTo({
    //                 left: firstRealSlide.offsetWidth,
    //                 behavior: 'auto'
    //             });
    //         }
    //     }
    // }
    // End of loopable slider on mobile

    const initMobileImageGallery = () => {
        const sliderWrapper = document.querySelector(".pdp-gallery-slider-wrapper");
        if (!sliderWrapper) return;

        sliderWrapper.innerHTML = "";

        const numSlides = currentMediaPerVariant.length;

        const firstClone = currentMediaPerVariant[0].cloneNode(true);
        if (firstClone.querySelector(":scope > div"))
            firstClone.querySelector(":scope > div").removeAttribute("data-fancybox");
        const lastClone = currentMediaPerVariant[numSlides - 1].cloneNode(true);
        if (lastClone.querySelector(":scope > div"))
            lastClone.querySelector(":scope > div").removeAttribute("data-fancybox");

        // Append cloned last image at the start, and first image at the end
        sliderWrapper.appendChild(lastClone);
        currentMediaPerVariant.forEach((image) => {
            if (image.classList.contains("pdp__media--prod-video")) {
                sliderWrapper.appendChild(image);
            } else {
                const cloneImage = image.cloneNode(true);
                sliderWrapper.appendChild(cloneImage);
                if (window.innerWidth < 900) {
                    if (cloneImage.querySelector(":scope > div")) {
                        const fancyBoxStr = cloneImage
                            .querySelector(":scope > div")
                            .getAttribute("data-fancybox-temp");
                        cloneImage
                            .querySelector(":scope > div")
                            .removeAttribute("data-fancybox-temp");
                        if (fancyBoxStr)
                            cloneImage
                                .querySelector(":scope > div")
                                .setAttribute("data-fancybox", fancyBoxStr);
                    }
                } else {
                    if (cloneImage.querySelector(":scope > div")) {
                        const fancyBoxStr = cloneImage
                            .querySelector(":scope > div")
                            .getAttribute("data-fancybox");
                        cloneImage
                            .querySelector(":scope > div")
                            .removeAttribute("data-fancybox");
                        if (fancyBoxStr)
                            cloneImage
                                .querySelector(":scope > div")
                                .setAttribute("data-fancybox-temp", fancyBoxStr);
                    }
                }
            }
        });

        sliderWrapper.appendChild(firstClone);

        calpak.pdpGalleryControlInfo.isTransitioning = false;
        // Set the slider to the actual first image (second in the new array)
        calpak.pdpGalleryControlInfo.currentIndex = 1;
        // sliderWrapper.style.transform = `translateX(-100%)`;

        // Touch tracking variables
        calpak.pdpGalleryControlInfo.touchStartX = 0;
        calpak.pdpGalleryControlInfo.currentTranslate = 0;
        calpak.pdpGalleryControlInfo.prevTranslate = 0;
        calpak.pdpGalleryControlInfo.isDragging = false;
        const swipeThreshold = 40; // Minimum swipe distance to trigger next/prev

        // Animation function with requestAnimationFrame
        function animateSlider() {
            updateSliderPosition(
                calpak.pdpGalleryControlInfo.currentTranslate,
                false
            );
            if (calpak.pdpGalleryControlInfo.isDragging)
                requestAnimationFrame(animateSlider);
        }

        const updateSliderPosition = function (
            translatePercentage,
            animate = true
        ) {
            calpak.pdpGalleryControlInfo.currentTranslate = translatePercentage;
            if (animate) {
                sliderWrapper.style.transition = "transform 0.5s ease";
            } else {
                sliderWrapper.style.transition = "none";
            }

            sliderWrapper.style.transform = `translateX(${translatePercentage}%)`;
        };

        updateSliderPosition(
            -calpak.pdpGalleryControlInfo.currentIndex * 100,
            false
        ); // Initialize without transition

        const prevButtonClicked = () => {
            if (calpak.pdpGalleryControlInfo.isTransitioning) return; // Prevent fast clicking during transitions
            calpak.pdpGalleryControlInfo.isTransitioning = true;

            calpak.pdpGalleryControlInfo.currentIndex--;
            updateSliderPosition(
                -calpak.pdpGalleryControlInfo.currentIndex * 100,
                true
            );

            const currentSlides = sliderWrapper.querySelectorAll(".pdp__media");
            // Smoothly loop back to the last real image if at the cloned first
            setTimeout(() => {
                if (calpak.pdpGalleryControlInfo.currentIndex === 0) {
                    sliderWrapper.style.transition = "none"; // Disable transition for instant move
                    calpak.pdpGalleryControlInfo.currentIndex = currentSlides.length - 2; // Move to last real image
                    updateSliderPosition(
                        -calpak.pdpGalleryControlInfo.currentIndex * 100,
                        false
                    );
                }
                calpak.pdpGalleryControlInfo.isTransitioning = false;
            }, 500); // Match the transition duration
        };

        if (!calpak.pdpGalleryControlInfo.isFuncAttached) {
            sliderWrapper.parentElement
                .querySelector(".slider__control--prev")
                .addEventListener("click", prevButtonClicked);
        }

        const nextButtonClicked = () => {
            if (calpak.pdpGalleryControlInfo.isTransitioning) return; // Prevent fast clicking during transitions
            calpak.pdpGalleryControlInfo.isTransitioning = true;

            calpak.pdpGalleryControlInfo.currentIndex++;
            updateSliderPosition(
                -calpak.pdpGalleryControlInfo.currentIndex * 100,
                true
            );
            const currentSlides = sliderWrapper.querySelectorAll(".pdp__media");
            // Smoothly loop back to the first real image if at the cloned last
            setTimeout(() => {
                if (
                    calpak.pdpGalleryControlInfo.currentIndex ===
                    currentSlides.length - 1
                ) {
                    sliderWrapper.style.transition = "none"; // Disable transition for instant move
                    calpak.pdpGalleryControlInfo.currentIndex = 1; // Move to first real image
                    updateSliderPosition(
                        -calpak.pdpGalleryControlInfo.currentIndex * 100,
                        false
                    );
                }
                calpak.pdpGalleryControlInfo.isTransitioning = false;
            }, 500); // Match the transition duration
        };

        if (!calpak.pdpGalleryControlInfo.isFuncAttached) {
            sliderWrapper.parentElement
                .querySelector(".slider__control--next")
                .addEventListener("click", nextButtonClicked);
        }

        // Handle touchstart event (when the user begins touching the screen)
        const handleTouchStart = function (event) {
            calpak.pdpGalleryControlInfo.touchStartX = event.touches[0].clientX;
            calpak.pdpGalleryControlInfo.isDragging = true;
            calpak.pdpGalleryControlInfo.prevTranslate = calpak.pdpGalleryControlInfo.currentTranslate;
            
            sliderWrapper.style.transition = "none";
            cancelAnimationFrame(calpak.pdpGalleryControlInfo.animationID);
            
            const animate = () => {
                sliderWrapper.style.transform = `translateX(${calpak.pdpGalleryControlInfo.currentTranslate}%)`;
                if (calpak.pdpGalleryControlInfo.isDragging) {
                    calpak.pdpGalleryControlInfo.animationID = requestAnimationFrame(animate);
                }
            };
            calpak.pdpGalleryControlInfo.animationID = requestAnimationFrame(animate);
        };

        // Handle touchmove event (when the user moves their finger)
        const handleTouchMove = function (event) {
            if (!calpak.pdpGalleryControlInfo.isDragging) return;
            
            const touchCurrentX = event.touches[0].clientX;
            const moveBy = touchCurrentX - calpak.pdpGalleryControlInfo.touchStartX;
            
            calpak.pdpGalleryControlInfo.currentTranslate =
                calpak.pdpGalleryControlInfo.prevTranslate + (moveBy / window.innerWidth) * 100;
        };
        
        const handleTouchEnd = function () {
            calpak.pdpGalleryControlInfo.isDragging = false;
            
            const moveBy = calpak.pdpGalleryControlInfo.currentTranslate - calpak.pdpGalleryControlInfo.prevTranslate;
            if (moveBy < -swipeThreshold) {
                nextButtonClicked();
            } else if (moveBy > swipeThreshold) {
                prevButtonClicked();
            } else {
                updateSliderPosition(-calpak.pdpGalleryControlInfo.currentIndex * 100);
                sliderWrapper.style.transition = "transform 0.4s ease-out";
            }
            
            cancelAnimationFrame(calpak.pdpGalleryControlInfo.animationID);
        };

        if (!calpak.pdpGalleryControlInfo.isFuncAttached) {
            sliderWrapper.addEventListener("touchstart", handleTouchStart);
            sliderWrapper.addEventListener("touchmove", handleTouchMove);
            sliderWrapper.addEventListener("touchend", handleTouchEnd);
        }
        calpak.pdpGalleryControlInfo.isFuncAttached = true;
    }


    let ismobile = false;
    const resizeFunc = function () {
        const sliderWrapper = document.querySelector(
            ".pdp__gallery-images"
        );
        if (!sliderWrapper) return;
        if (window.innerWidth < 900) {
            document.querySelector(".pdp-gallery-slider-container").style.display = "none";
            currentMediaPerVariant.forEach((image) => {
                if (image.querySelector(":scope > div")) {
                    const fancyBoxStr = image
                        .querySelector(":scope > div")
                        .getAttribute("data-fancybox");
                    image
                        .querySelector(":scope > div")
                        .removeAttribute("data-fancybox");
                    if (fancyBoxStr)
                        image
                            .querySelector(":scope > div")
                            .setAttribute("data-fancybox-temp", fancyBoxStr);
                }
            });
            const currentSlides = sliderWrapper.querySelectorAll(".pdp__media");
            currentSlides.forEach((image) => {
                if (image.querySelector(":scope > div")) {
                    const fancyBoxStr = image
                        .querySelector(":scope > div")
                        .getAttribute("data-fancybox-temp");
                    image
                        .querySelector(":scope > div")
                        .removeAttribute("data-fancybox-temp");
                    if (fancyBoxStr)
                        image
                            .querySelector(":scope > div")
                            .setAttribute("data-fancybox", fancyBoxStr);
                }
            });
            if(!ismobile){
                initMobileImageGallery();
                ismobile = true
            }
        } else {
            const currentSlides = sliderWrapper.querySelectorAll(".pdp__media");
            currentSlides.forEach((image) => {
                if (image.querySelector(":scope > div")) {
                    const fancyBoxStr = image
                        .querySelector(":scope > div")
                        .getAttribute("data-fancybox");
                    image
                        .querySelector(":scope > div")
                        .removeAttribute("data-fancybox");
                    if (fancyBoxStr)
                        image
                            .querySelector(":scope > div")
                            .setAttribute("data-fancybox-temp", fancyBoxStr);
                }
                let medias = pdpSlides.querySelectorAll(".pdp__media.pdp__media--active");
                if (image.classList.contains("pdp__media--prod-video") && !image.classList.contains("pdp__media--second-prod-video")) {
                    const pos = image.dataset.videoOrder
                    pdpSlides.insertBefore(image, medias[pos - 1]);
                } else if (image.classList.contains("pdp__media--prod-video") && image.classList.contains("pdp__media--second-prod-video")) {
                    const pos = image.dataset.videoOrder
                    pdpSlides.insertBefore(image, medias[pos - 1]);
                }
            });

            currentMediaPerVariant.forEach((image) => {
                if (image.querySelector(":scope > div")) {
                    const fancyBoxStr = image
                        .querySelector(":scope > div")
                        .getAttribute("data-fancybox-temp");
                    image
                        .querySelector(":scope > div")
                        .removeAttribute("data-fancybox-temp");
                    if (fancyBoxStr)
                        image
                            .querySelector(":scope > div")
                            .setAttribute("data-fancybox", fancyBoxStr);
                }
            });
            document.querySelector(".pdp-gallery-images").style.display = "block";
            sliderWrapper.innerHTML = "";
        }
    };
    window.addEventListener("resize", resizeFunc);
    resizeFunc();

}




calpak.pdpGalleryUpdate = pdpGalleryUpdate

const pdpHandleUpsell = function pdpHandleUpsell(option) {
    const productUnits = document.querySelectorAll('.pdp__upsell .product-unit');

    let promises = [];
    productUnits.forEach(product => {
        if(!product.classList.contains('product-unit--loaded')) promises.push(calpak.activateProductUnit(product))
    });

    if(promises.length == 0) return matchProductUnitsToOption(productUnits, option);

    Promise.all(promises).then(() => matchProductUnitsToOption(productUnits, option));
}
calpak.pdpHandleUpsell = pdpHandleUpsell

const pdpHandleBundle = function pdpHandleBundle(option) {
    const productUnits = document.querySelectorAll('.make-a-set-container .bundle-items .product-unit');

    let promises = [];
    productUnits.forEach(product => {
        if(!product.classList.contains('product-unit--loaded')) promises.push(calpak.activateProductUnit(product))
    });

    if(promises.length == 0) return matchProductUnitsToOption(productUnits, option);

    Promise.all(promises).then(() => matchProductUnitsToOption(productUnits, option));
}
calpak.pdpHandleBundle = pdpHandleBundle

const matchBundleSwatchesToOption = function matchBundleSwatchesToOption(option) {
    const swatchesContainers = document.querySelectorAll('.make-a-set-container .bundle-swatches-groups.swatches-container');
    swatchesContainers.forEach(swatchesContainer => {
        if(!swatchesContainer)
            return;
        const color = option.getAttribute('data-option1');

        let newSwatch = swatchesContainer?.querySelector(`.color-swatch[data-value="${color}"]`)
        if(!newSwatch?.classList.contains('product-option--na')) {
        } else {
            let posibleNewSwatch = swatchesContainer.querySelector(`.color-swatch[data-available="true"]`);
            if(posibleNewSwatch) {
                newSwatch = posibleNewSwatch;
            }
        }

        const activeFirst = swatchesContainer?.querySelector('.color-swatch--first');
        if(activeFirst) activeFirst.classList.remove('color-swatch--first');

        newSwatch?.classList.add('color-swatch--first');
        newSwatch?.click();
    })
}

calpak.matchBundleSwatchesToOption = matchBundleSwatchesToOption

const pdpHandleFeaturedCollection = function pdpHandleFeaturedCollection(option) {
    const productUnits = document.querySelectorAll('.shopify-section--pdp-featured .product-unit');

    let promises = [];
    productUnits.forEach(product => {
        if(!product.classList.contains('product-unit--loaded')) promises.push(calpak.activateProductUnit(product))
    });

    if(promises.length == 0) return matchProductUnitsToOption(productUnits, option, false);

    Promise.all(promises).then(() => matchProductUnitsToOption(productUnits, option, false));
}
calpak.pdpHandleFeaturedCollection = pdpHandleFeaturedCollection

const pdpUpdateURL = function pdpUpdateURL(productdata, options) {

    let product = productdata || window.product;

    let url_vars = '';
    if(document.location.href.indexOf('?') > -1) {
        url_vars = document.location.href.split('?');
        url_vars = '?' + url_vars[1];
    }

    let sizeValues = product.variants.map(variant => variant.option2);
    sizeValues = calpak.collect(sizeValues);
    sizeValues = sizeValues.unique().all();

    let attr = options[0];
    let attr1 = options[1];
    var urlhandle = ''
    if(attr1 && sizeValues.length > 1){
        urlhandle = `${attr},${options[1]}`;
    }else{
        urlhandle = `${attr}`;
    }

    if(document.location.href.indexOf('?preview_key=') === -1) {
        let eaURL = false;
        if(document.location.href.indexOf('/early-access') > -1) eaURL = true;

        window.history.replaceState({}, '', `/products/${product.handle}/${eaURL?'early-access-':''}${urlhandle}${url_vars}`);
        document.querySelector('link[rel="canonical"]').setAttribute("href", location.href);
        const colorName = calpak.capitalizeEachWord(calpak.unhandleize(attr));

        let sizeName = ""
        if(attr1)
            sizeName = attr1;
        const target_keyword = window.calpak.target_keyword;
        let title = `${product.title} in ${colorName}`;
        let handledProdName = calpak.handleize(product.title);
        if(handledProdName.includes('gift-card')) {
            title = product.title;
        }
        let description = `Shop the ${colorName} ${target_keyword} - ${product.title} at CALPAK. Free shipping on US orders $75+.`;
        if(product.options[1]?.includes("Color")){
            const colorName2 = calpak.capitalizeEachWord(calpak.unhandleize(attr1))
            title = `${product.title} in ${colorName}${sizeName?" + "+colorName2:""}`;
            description = `Shop the ${colorName}${sizeName?" + "+colorName2:""} ${target_keyword} - ${product.title} at CALPAK. Free shipping on US orders $75+.`;

        }
        // const description = `Shop the ${colorName}${sizeName?"/"+sizeName:""} ${target_keyword} - ${product.title} at CALPAK. Free shipping on US orders $75+.`;

        const pdpTitle = document.querySelectorAll(".pdp__title");
        const pdpFloatingTitle = document.querySelector(".pdp__floating-title");

        if (pdpTitle.length > 0) {
            pdpTitle.forEach(el => {
                el.innerHTML = title;
            });
        }
        if (pdpFloatingTitle) pdpFloatingTitle.innerHTML = title;

        document.title = title + " | CALPAK";

        const metaDescription = document.querySelector('meta[name="description"]')
        if(metaDescription) metaDescription.setAttribute("content", description);

        const ogTitle = document.querySelector('meta[property="og:title"]');
        if(ogTitle) ogTitle.setAttribute("content", title);

        const ogDescription = document.querySelector('meta[property="og:description"]');
        if(ogDescription) ogDescription.setAttribute("content", description);

        const ogUrl = document.querySelector('meta[property="og:url"]')
        if(ogUrl) ogUrl.setAttribute("content", location.href);

        const twitterTitle = document.querySelector('meta[property="twitter:title"]');
        if(twitterTitle) twitterTitle.setAttribute("content", title);

        const twitterDescription = document.querySelector('meta[property="twitter:description"]');
        if(twitterDescription) twitterDescription.setAttribute("content", description);

        // const option = calpak.capitalize(calpak.unhandleize(attr))
        // document.title = `${product.title} in ${option} | CALPAK`;
        // document.querySelector('meta[property="og:url"]').setAttribute("content", location.href);
        // document.querySelector('meta[property="og:title"]').setAttribute("content", document.title);
        
        if (options?.length) {
            const selectedVariant = product.variants.find(
                (variant) => variant.title.toLowerCase() === options[0].toLowerCase()
            );

            if (selectedVariant?.customized_description) {
                const parsedDescription = convertMetafieldToHTML(selectedVariant.customized_description);
                const pdpDescription = document.querySelector('.pdp__description .accordion__content');
                
                if (pdpDescription)
                    pdpDescription.innerHTML = parsedDescription;
            }
        }
    }
}
calpak.pdpUpdateURL = pdpUpdateURL

const convertMetafieldToHTML = (metafieldContent) => {
    if (!metafieldContent || !metafieldContent.children) return '';

    return metafieldContent.children
    .map((node) => {
      switch (node.type) {
        case "heading":
          return `<h${node.level}>${node.children[0].value}</h${node.level}>`;

        case "list":
          const listTag = node.listType === "unordered" ? "ul" : "ol";
          return `<${listTag}>${node.children
            .map((item) => `<li>${item.children[0].value}</li>`)
            .join("")}</${listTag}>`;

        case "paragraph":
            return `<p>${node.children
                .map((item) => {
                let content = "";

                if (item.type === "text") {
                    let textValue = item.value.replace(/\n/g, "<br>"); // Convert `\n` to `<br>`

                    content = item.bold
                    ? `<strong>${textValue}</strong>`
                    : item.italic
                    ? `<em>${textValue}</em>`
                    : textValue;
                }

                if (item.type === "link") {
                    content = `<a href="${item.url}" target="${item.target}">${
                    item.bold
                        ? `<strong>${item.children[0].value}</strong>`
                        : item.italic
                        ? `<em>${item.children[0].value}</em>`
                        : item.children[0].value
                    }</a>`;
                }

                return content;
                })
                .join(" ")}</p>`;

        default:
          return "";
      }
    })
    .join("");
}

const pdpHandleDescriptions = function pdpHandleDescriptions(pdpInfo, option) {
    const actives = pdpInfo.querySelectorAll('[data-variant][data-current]');
    actives.forEach(active => active.removeAttribute('data-current'));

    const toActivate = pdpInfo.querySelectorAll(`[data-variant="${option.value}"]`);
    toActivate.forEach(toAct => toAct.setAttribute('data-current', ''));
}
calpak.pdpHandleDescriptions = pdpHandleDescriptions
const changeBadgeAbsolutePosition = e => {
    setTimeout(() => {
    if(window.location.pathname.includes('product')) {
        if(window.innerWidth < 900) {
            let slider = document.querySelector('.pdp__gallery-container .slider__wrapper');
            let badge = document.querySelector('.pdp__gallery-container .product-label--badge-mobile-bottom');
            if(badge) {
                badge.style.marginTop = `0px`;
                badge.style.top = `${slider.clientHeight - badge.clientHeight - 10}px`;
            } else {
                badge = document.querySelector('.pdp__gallery-container .product-label--badge');
                if (badge) {
                    badge.style.marginTop = ``;
                    badge.style.top = ``;
                }
            }
        } else {
            let first_media = document.querySelector('.pdp__gallery-container .pdp__media--active');
            let badge = document.querySelector('.pdp__gallery-container .product-label--badge-desktop-bottom');
            if(badge && first_media) {
                badge.style.marginTop = `0px`;
                badge.style.top = `${first_media.clientHeight - badge.clientHeight - 26}px`;
            } else {
                badge = document.querySelector('.pdp__gallery-container .product-label--badge');
                if (badge) {
                    badge.style.marginTop = ``;
                    badge.style.top = ``;
                }
            }
        }
    }
    }, 300);
};

// fancybox with monolithic color scheme

function initFancyboxVariantGalleries(){
    changeBadgeAbsolutePosition()
    Fancybox.bind('[data-fancybox="gallery"]', {
        on: {
            "Carousel.Panzoom.ready": () => {
                setTimeout(() => {
                    document.querySelectorAll('.f-carousel__toolbar .f-button[title]').forEach(button => {
                        if(button.getAttribute('title')) {
                            button.setAttribute('aria-label', button.getAttribute('title'));
                        }
                    });
                }, 100);
            },
        },
        Toolbar: {
            items: fancyBoxCustomItems
        }
    });
    const mediaColors = [...document.querySelectorAll(".pdp__media")]
    const mediaUniqueColors = [...new Set(mediaColors.map(ele => ele.dataset.variants))]
    
    for (let i = 0; i < mediaUniqueColors.length; i++) {
        const color = mediaUniqueColors[i];
        if (color.length) {
            const activeMedias = [...document.querySelectorAll(`.pdp__media[data-variants="${color}"] img`)]
            Fancybox.bind(`[data-fancybox="gallery-${color}"]`, {
                on: {
                    "Carousel.ready Carousel.change": (fancybox) => {
                        let slide = fancybox.getSlide();
                        let slides = fancybox.getCarousel().getSlides();
                        let currentIndex = slide.index;
                        setTimeout(() => {
                            document.querySelectorAll(".fancybox__container .fancybox__slide").forEach(item => {
                                item.setAttribute("role", "group");
                                item.setAttribute("aria-label", `slide ${Number(currentIndex) + 1} of ${slides.length}`);
                                item.querySelector("img").alt = activeMedias[Number(currentIndex)].alt;
                            });
                            document.querySelectorAll(".f-thumbs__viewport .f-thumbs__slide button").forEach(item => {
                                item.removeAttribute("aria-current");
                                item.setAttribute("tabindex", "0");
                                if (item.parentElement.classList.contains("is-selected")) {
                                    item.setAttribute("aria-current", true);
                                }
                                item.querySelector("img").alt = activeMedias[Number(currentIndex)].alt;
                            });
                            const counter = document.querySelector(".f-counter");
                            if (counter) {
                                const currentPage = Number(currentIndex) + 1;
                                const totalPages = slides.length;
                                counter.setAttribute("aria-label", `Image ${currentPage} of ${totalPages}`);
                                counter.setAttribute("role", "status");
                                counter.querySelectorAll("span").forEach(span => {
                                    span.setAttribute("aria-hidden", "true");
                                });
                            }
                            document.querySelectorAll('.f-carousel__toolbar .f-button[title]').forEach(button => {
                                if(button.getAttribute('title')) {
                                    button.setAttribute('aria-label', button.getAttribute('title'));
                                }
                            });
                        }, 1000);
                    },
                    "Carousel.Panzoom.ready": () => {
                        setTimeout(() => {
                            document.querySelectorAll('.f-carousel__toolbar .f-button[title]').forEach(button => {
                                if(button.getAttribute('title')) {
                                    button.setAttribute('aria-label', button.getAttribute('title'));
                                }
                            });
                        }, 100);
                    },
                }
            });
        }
    }
}

initFancyboxVariantGalleries();

// Remove redundant button attributes from fancybox elements inside buttons
document.querySelectorAll('button [data-fancybox]').forEach(element => {
    element.removeAttribute('role');
    element.removeAttribute('tabindex');
    element.removeAttribute('aria-label');
});

document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
        const target = e.target;
        if (target.classList.contains('pdp__media')) {
            const fancyboxElement = target.querySelector('[data-fancybox^="gallery"]');
            if (fancyboxElement) {
                e.preventDefault();
                fancyboxElement.click();
            }
        }
    }
});

// Setting free shipping location
const locationContainers = document.querySelectorAll("section.pdp__free-shipping-text");

locationContainers.forEach( (locationContainer) => {
    const productPrice = parseInt(locationContainer.dataset.productPrice);
    const shippingPrice = parseInt(locationContainer.dataset.shippingPrice);
    const available = locationContainer.dataset.available;
    if (typeof locationContainer != 'undefined') {
        const locationText = locationContainer.querySelector("#freeShippingLocation");
        if(locationText == null)
            return;

        // console.log('-----------calpak.userLocationData PDP ');
        // console.log(calpak.userLocationData);
        // console.log(calpak.userRegionCode);
        // console.log(calpak.userRegionName);
        // console.log(calpak.userFreeShipping);

     //   if (calpak.userFreeShipping === "true") {
            locationContainer.dataset.locationAvailable = "true";
            if (typeof calpak.userRegionName != 'undefined' && calpak.userRegionName !== ""){
                locationText.innerHTML = "to " + calpak.userRegionName;
            }
            if (available === "true") {
                if (productPrice >= shippingPrice) {
                    locationContainer.style.display = "block";
                    //handleDisplayLogic();
                }
                else{
            locationContainer.style.display = "none";
                }
            }
        // } else {
        //     locationContainer.dataset.locationAvailable = "false";
        //     locationContainer.style.display = "none";
        //     //handleDisplayLogic();
        // }
    }
});


window.addEventListener("resize", changeBadgeAbsolutePosition);
changeBadgeAbsolutePosition()

window.addEventListener('DOMContentLoaded', () => {
    const pdpOptions = document.querySelectorAll('.product-option');
    const includesTextWrapperForLuggageCovers = Array.from(document.querySelectorAll('.inlcudes-on-set'));

    if(pdpOptions){
        [].map.call(pdpOptions, option => {
            option.addEventListener('click', () => {
                const optVal = option.getAttribute('data-value');
                if(includesTextWrapperForLuggageCovers.length > 1) {
                    if(optVal === "set-of-2") {
                        includesTextWrapperForLuggageCovers.map(includesTextWrapperForLuggageCover => {
                            includesTextWrapperForLuggageCover.querySelector(".set-of-3").classList.add('display-none')
                            includesTextWrapperForLuggageCover.querySelector(".set-of-2").classList.remove('display-none')
                            includesTextWrapperForLuggageCover.classList.remove('unseen')
                            includesTextWrapperForLuggageCover.classList.add('seen')
                        })

                    } else if(optVal === "set-of-3") {
                        includesTextWrapperForLuggageCovers.map(includesTextWrapperForLuggageCover => {
                            includesTextWrapperForLuggageCover.querySelector(".set-of-2").classList.add('display-none')
                            includesTextWrapperForLuggageCover.querySelector(".set-of-3").classList.remove('display-none')
                            includesTextWrapperForLuggageCover.classList.remove('unseen')
                            includesTextWrapperForLuggageCover.classList.add('seen')
                        })

                    } else {
                        includesTextWrapperForLuggageCovers.map(includesTextWrapperForLuggageCover => {
                            includesTextWrapperForLuggageCover.querySelector(".set-of-2").classList.add('display-none')
                            includesTextWrapperForLuggageCover.querySelector(".set-of-3").classList.add('display-none')
                            includesTextWrapperForLuggageCover.classList.remove('seen')
                            includesTextWrapperForLuggageCover.classList.add('unseen')
                        })
                    }
                }
            })
        })
    }
    // Additional ADA rules
    document.querySelector('.pdp__payments svg')?.removeAttribute("aria-hidden");
});

// turned off below
function infiniteSlideMobile() {
    const pdpThumbsMobile = document.querySelector('.pdp__gallery[data-slider-on="mobile"]');
    if (pdpThumbsMobile){
        if (!pdpThumbsMobile.classList.contains('have-clones')) {
            pdpThumbsMobile.classList.add('have-clones');
            const activeSlides = pdpThumbsMobile.querySelectorAll('.pdp__media--active.slide');

            const btnNext = pdpThumbsMobile.previousElementSibling.querySelector('.slider__control--prev');
            const btnPrev = pdpThumbsMobile.previousElementSibling.querySelector('.slider__control--next');
            btnNext.style.opacity = 1
            btnPrev.style.opacity = 1

            if (activeSlides.length > 0) {
                const firstActiveSlide = activeSlides[0];
                const lastActiveSlide = activeSlides[activeSlides.length - 1];

                const firstTargetDiv = pdpThumbsMobile.querySelector('.front');
                firstTargetDiv.classList.add('pdp__media--active', 'slide');

                const secondTargetDiv = pdpThumbsMobile.querySelector('.back');
                secondTargetDiv.classList.add('pdp__media--active', 'slide');

                if (firstTargetDiv && secondTargetDiv) {
                    firstTargetDiv.innerHTML = lastActiveSlide.innerHTML;
                    secondTargetDiv.innerHTML = firstActiveSlide.innerHTML;
                }

                calpak.checkSlider(pdpThumbsMobile, 0, false, true);
                const slideWidth = firstActiveSlide.offsetWidth;

                pdpThumbsMobile.scrollTo({
                    left: slideWidth,
                    behavior: 'auto'
                });
            }
        }
    }
}

// // temporary turn off infiniteSlideMobile while it's sent back for fix.
// window.addEventListener('DOMContentLoaded', () => {
//     if (window.innerWidth <= 900){
//         infiniteSlideMobile();
//     }
//     window.addEventListener('resize', () => {
//         if (window.innerWidth <= 900){
//             infiniteSlideMobile();
//         }
//     });
// });

window.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll("video");
  videos.forEach((video) => {
    const tracks = video.textTracks;

    for (let i = 0; i < tracks.length; i++) {
        tracks[i].mode = 'hidden';
    }

    if (window.innerWidth <= 900) {
      video.controls = false; // Hide controls by default

      video.addEventListener("click", () => {
        if (video.controls) {
          video.controls = false; // Hide controls if already showing
        } else {
          video.controls = true; // Show controls when clicked
        }
      });

      video.addEventListener("blur", () => {
        video.controls = false; // Hide controls when the video loses focus
      });
    }
  });
});

//sticky add to cart button
document.addEventListener("DOMContentLoaded", function () {
    const scrollCheckElement = document.querySelector('.pdp__floating-submit');
    const scrollCheck = function () {
        if (window.scrollY > 350) {
            scrollCheckElement?.classList.remove('pdp-submit-sticky');
        } else {
            scrollCheckElement?.classList.add('pdp-submit-sticky');
        }
    }

    if (typeof scrollCheckElement != "undefined"){
        window.addEventListener('scroll', calpak.debounce(scrollCheck,100) );
        //   window.addEventListener('scroll', scrollCheck );
    }
});

const YOTPO_SCHEMA_APP_KEY = "KOCR5OsYMW1ov7fOJK97onbPH1Bb7AqQfjsUeVfJ";

const applyReviewToProductSchema = (schemaScript, review) => {
    if (!schemaScript || !review?.user?.displayName || !review?.content) return false;
    try {
        const schema = JSON.parse(schemaScript.textContent);
        schema.review = {
            "@type": "Review",
            author: {
                "@type": "Person",
                name: review.user.displayName,
            },
            reviewBody: review.content,
            reviewRating: {
                "@type": "Rating",
                ratingValue: String(review.score),
                bestRating: "5",
            },
        };
        schemaScript.textContent = JSON.stringify(schema);
        return true;
    } catch (error) {
        console.error("Product schema review hydration failed", error);
        return false;
    }
};

const hydrateProductSchemaReviewFromApi = async (schemaScript) => {
    const productId = schemaScript?.dataset?.yotpoProductId;
    if (!productId) return false;

    const response = await fetch(
        `https://api-cdn.yotpo.com/v3/storefront/store/${YOTPO_SCHEMA_APP_KEY}/product/${productId}/reviews?page=1&perPage=10&sort=date&direction=desc`
    );
    if (!response.ok) return false;

    const json = await response.json();
    const fiveStarReview = json.reviews?.find((review) => review.score === 5);
    if (!fiveStarReview) return false;

    return applyReviewToProductSchema(schemaScript, fiveStarReview);
};

const hydrateProductSchemaReviewFallback = async () => {
    const schemaScript = document.querySelector("#product-schema");
    if (!schemaScript) return;

    try {
        const schema = JSON.parse(schemaScript.textContent);
        if (schema.review?.author?.name && schema.review?.reviewBody) return;
    } catch (error) {
        return;
    }

    try {
        await hydrateProductSchemaReviewFromApi(schemaScript);
    } catch (error) {
        console.error("Yotpo API product schema review fetch failed", error);
    }
};

function waitForElement(selector) {
    return new Promise((resolve) => {
        const checkForElement = () => {
            const element = document.querySelector(selector);
            if (element) {
                resolve(element);
            } else {
                requestAnimationFrame(checkForElement);
            }
        };
        checkForElement();
    });
}

if (document.querySelector('.template-product')) {
    const schemaScript = document.querySelector("#product-schema");
    const reviewsCount = parseInt(schemaScript?.dataset?.yotpoReviewsCount || "0", 10);
    if (reviewsCount > 0) {
        hydrateProductSchemaReviewFallback();
    }

    waitForElement('.yotpo-reviews-list').then(() => {
        const starRatingsElement = document.querySelector('.pdp__header .yotpo-star__ratings');
        if (starRatingsElement) {
            starRatingsElement.classList.add('clickable');

            starRatingsElement.addEventListener('click', () => {
                const targetElement = document.getElementById('yotpo-reviews-main-widget');
                if (targetElement) {
                    const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({
                        top: elementPosition,
                        behavior: 'smooth'
                    });
                }
            });
        }
    });
}

calpak.updatePdpSwatchesForCalifornia = function updatePdpSwatchesForCalifornia() {
    // calpak.setLocation();
    if (calpak.userRegionCode !== "CA" || !calpak.hideSkusCalifornia?.length) return;

    const restrictedSkus = new Set(calpak.hideSkusCalifornia?.map(sku => sku.toUpperCase()));
    const pdpGrid = document.querySelector(".pdp__grid");
    const qvBody = document.querySelector(".qv__body");

    const handleSwatchStatus = (swatch) => {
        const sku = swatch?.getAttribute("data-sku")?.toUpperCase();
        if (!sku || !restrictedSkus.has(sku)) return false;
        return true;
    };

    const activeSwatch = document.querySelector(".pdp__swatches .color-swatch--active");
    if (activeSwatch && handleSwatchStatus(activeSwatch)) {
        pdpGrid?.setAttribute("data-status", "sold-out");
        qvBody?.setAttribute("data-status", "sold-out");
    }

    document.querySelectorAll(".pdp__swatches-groups .pdp__swatches .color-swatch")?.forEach(swatch => {
        handleSwatchStatus(swatch) && swatch.classList.add("product-option--na");
    });
}

// Temp disable california check
// await calpak.setLocation
// calpak.updatePdpSwatchesForCalifornia();

function skeletonLoader(wrapper = document) {
    let skeleton = wrapper.querySelectorAll(".skeleton-loader");
    let button = wrapper.querySelectorAll(".skeleton-trigger.hidden");

    if (skeleton?.length && button?.length) {
        skeleton.forEach(item => {
            item.remove(); 
        }); 
        button.forEach(item => {
            item.classList.remove("hidden");
        });
    }
}

document.addEventListener("calpak:loaded", function () {
    skeletonLoader();
});

window.addEventListener("load", function () {
    if (document.querySelectorAll(".skeleton-trigger.hidden").length) {
        skeletonLoader();
    }
});

// Helper function to identify and classify video elements
function identifyVideoElements(mediaElements, classPrefix = 'pdp-thumb-media') {
    const videos = {
        varVideo: false,
        firstProdVideo: false,
        secondProdVideo: false
    };

    for (let i = 0; i < mediaElements.length; i++) {
        const element = mediaElements[i];
        
        if (element.classList.contains(`${classPrefix}--first-prod-video`)) {
            videos.firstProdVideo = element;
        }
        if (element.classList.contains(`${classPrefix}--second-prod-video`)) {
            videos.secondProdVideo = element;
        }
        if (element.classList.contains(`${classPrefix}--var-video`)) {
            videos.varVideo = element;
        }

        element.classList.add(`${classPrefix}--active`, 'slide');
    }

    return videos;
}

// Helper function to position a video element
function positionVideoElement(video, videoOrder, container, filteredElements) {
    if (!video || !videoOrder || videoOrder <= 0 || !container) return;

    const targetPosition = Math.min(videoOrder - 1, filteredElements.length - 1);
    
    if (filteredElements[targetPosition]) {
        container.insertBefore(video, filteredElements[targetPosition]);
    } else if (filteredElements.length > 0) {
        container.appendChild(video);
    }
}

// Helper function to handle video repositioning
function repositionVideos(videos, container, allElements, pdpVideoOrder, pdpSecondVideoOrder) {
    if (!container) return;

    // Filter out videos from regular elements for positioning reference
    const filteredElements = [...allElements].filter(media => 
        media !== videos.firstProdVideo && media !== videos.secondProdVideo
    );

    // Position first prod video
    positionVideoElement(videos.firstProdVideo, pdpVideoOrder, container, filteredElements);
    
    // Position second prod video
    positionVideoElement(videos.secondProdVideo, pdpSecondVideoOrder, container, filteredElements);
}


function initCustomYoptoReviews(container) {
  if (!container) return;
  const YOTPO_APP_KEY = "KOCR5OsYMW1ov7fOJK97onbPH1Bb7AqQfjsUeVfJ";
  const PRODUCT_ID = container.dataset.productId; // Shopify product ID

  let currentSlide = 0;
  let reviews = [];
  let itemsPerPage = 3; // Now showing 3 items (rating card + 2 reviews)

  const totalItems = parseInt(container.dataset.reviewsCount);

  // Initialize reviews
  loadReviews();

  // Event listeners
  container.querySelector(".carousel-prev").addEventListener("click", () => {
    if (isMobileDevice()) {
      itemsPerPage = 2;
    }
    if (currentSlide > 0) {
      currentSlide--;
    } else {
      currentSlide = totalItems - (isMobileDevice() ? 0 : itemsPerPage - 1); // Adjust for rating card
    }
    updateCarousel();
  });

  container.querySelector(".carousel-next").addEventListener("click", () => {
    if (isMobileDevice()) {
      itemsPerPage = 2;
    }
    if (currentSlide < totalItems - (isMobileDevice() ? 0 : itemsPerPage - 1)) {
      currentSlide++;
    } else {
      currentSlide = 0;
    }
    updateCarousel();
  });

  async function loadReviews() {
    try {
      let allFiveStars = [];
      let page = 1;
      let keepFetching = true;
      let bottomline = {};

      while (keepFetching) {
        const res = await fetch(
          `https://api-cdn.yotpo.com/v3/storefront/store/${YOTPO_APP_KEY}/product/${PRODUCT_ID}/reviews?page=${page}&perPage=10&sort=date&direction=desc`
        );
        const json = await res.json();

        bottomline = json.bottomline;
        const fiveStars = json.reviews.filter((r) => r.score === 5);
        allFiveStars.push(...fiveStars);

        if (allFiveStars.length >= totalItems) keepFetching = false;
        page++;
      }

      displayReviews(allFiveStars, bottomline);
      container.querySelector(".reviews-content").style.display = "block";
    } catch (error) {
      console.error("Error loading reviews:", error);
    }
  }

  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  function displayReviews(allFiveStars, bottomline) {
    // Store reviews and setup carousel
    reviews = allFiveStars.slice(0, totalItems);

    // Create average rating card HTML
    const averageRatingCard = `
      <div class="average-rating-card">
        <div class="rating-number">${bottomline.averageScore.toFixed(1)}</div>
        <div class="rating-details">
          <div class="stars">${generateStars(bottomline.averageScore)}</div>
          <p>Based on ${bottomline.totalReview} reviews</p>
        </div>
        <button class="write-review-btn">Write A Review</button>
        <a class="see-all-reviews-btn" href="#yotpo-reviews-main-widget">See All Reviews</a>
      </div>
    `;

    // Create review items HTML
    const reviewItems = reviews
      .map(
        (review) => `
      <div class="review-item">
        <div class="review-header">
          <div class="review-rating">
            ${generateStars(review.score)}
          </div>
        </div>
        <div class="review-content">
          ${review.content}
        </div>
        <div class="review-footer">
          <div class="reviewer-name">
            <span>${review.user.displayName}</span>
            <span class="verified-buyer">${
              review.verifiedBuyer ? "Verified Buyer" : ""
            }</span>
          </div>
          <div class="review-date">${formatDate(review.createdAt)}</div>
        </div>
      </div>
    `
      )
      .join("");

    // Display all items in carousel (rating card + reviews)
    const reviewsTrack = container.querySelector(".reviews-track");
    reviewsTrack.innerHTML = averageRatingCard + reviewItems;

    setTimeout(() => {
      if (isMobileDevice()) {
        if (reviewsTrack.scrollWidth - reviewsTrack.clientWidth <= 0) return;
        const scrollbar = document.createElement("div");
        scrollbar.classList.add("custom-scrollbar");
        const scrollbarThumb = document.createElement("div");
        scrollbarThumb.classList.add("custom-scrollbar-thumb");
        scrollbar.appendChild(scrollbarThumb);
        reviewsTrack.parentElement.appendChild(scrollbar);
        reviewsTrack.parentElement.style.setProperty(
          "--scroll-pos",
          reviewsTrack.scrollLeft
        );
        scrollbarThumb.style.left = `calc(var(--scroll-pos) / ${
          reviewsTrack.scrollWidth - reviewsTrack.clientWidth
        } * ${scrollbar.clientWidth - scrollbarThumb.clientWidth}px)`;
        let isDragging = false;
        let startX;
        let scrollLeftStart;
        let thumbPos = 0;

        scrollbarThumb.addEventListener(
          "touchstart",
          (e) => {
            isDragging = true;
            startX = e.touches[0].pageX;
            scrollLeftStart = reviewsTrack.scrollLeft;
            thumbPos = scrollbarThumb.offsetLeft;
            e.preventDefault(); // Prevent scrolling the page
          },
          { passive: false }
        );

        scrollbarThumb.addEventListener(
          "touchmove",
          (e) => {
            if (!isDragging) return;
            const touchX = e.touches[0].pageX;
            const moveX = touchX - startX;
            reviewsTrack.scrollLeft =
              scrollLeftStart +
              (moveX / scrollbar.clientWidth) * reviewsTrack.scrollWidth;
            let pos = thumbPos + moveX;
            if (pos <= 0) pos = 0;
            if (pos >= scrollbar.clientWidth - scrollbarThumb.clientWidth)
              pos = scrollbar.clientWidth - scrollbarThumb.clientWidth;
            scrollbarThumb.style.left = pos + "px";
          },
          { passive: false }
        );

        scrollbarThumb.addEventListener("touchend", () => {
          isDragging = false;
          scrollbarThumb.style.left = `calc(var(--scroll-pos) / ${
            reviewsTrack.scrollWidth - reviewsTrack.clientWidth
          } * ${scrollbar.clientWidth - scrollbarThumb.clientWidth}px)`;
        });
      }
      reviewsTrack.addEventListener(
        "scroll",
        function () {
          reviewsTrack.parentElement.style.setProperty(
            "--scroll-pos",
            reviewsTrack.scrollLeft
          );
        },
        { passive: true }
      );
    }, 300);

    window.addEventListener("click", async (e) => {
      if (e.target.classList.contains("write-review-btn")) {
        if (document.querySelector("#yotpo-main-widget-btn"))
          document.querySelector("#yotpo-main-widget-btn").click();
      }
    });
    updateCarousel();
  }

  function updateCarousel() {
    const track = container.querySelector(".reviews-track");
    const itemWidth =
      track.querySelector(".review-item").getBoundingClientRect().width + 20;
    track.scrollLeft = currentSlide * itemWidth;
  }

  function generateStars(rating) {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    let starsHTML = "";

    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        starsHTML += '<span class="star filled">★</span>';
      } else if (i === fullStars && hasHalfStar) {
        starsHTML += '<span class="star filled">★</span>';
      } else {
        starsHTML += '<span class="star">★</span>';
      }
    }

    return starsHTML;
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
    });
  }
}

document.addEventListener("calpak:loaded", function () {
  const customYoptoReview = document.querySelector(".customer-reviews-block");
  initCustomYoptoReviews(customYoptoReview);
});

(function(){
  async function loadComparison(btn){
    const wrap = document.querySelector('.shopify-section--single-product .pdp__grid');
    if(!wrap) return;
    console.log(wrap.querySelector("#popup-content"))
    if(wrap.querySelector("#popup-content") != null){
        calpak.Popupopen();
        return;
    }
    document.querySelector('.loading-overlay').classList.add('active');
    btn?.setAttribute('aria-busy','true');
    try{
    //   const url = `/products/${btn.dataset.productHandle}${window.location.search ? '&' : '?'}section_id=pdp-comparison-popup&variant=${document.querySelector(`.color-swatch.color-swatch--active`).dataset.variantId}`;
      const url = window.location.href + (window.location.search ? '&' : '?') + 'section_id=pdp-comparison-popup';
      const res = await fetch(url, { headers:{ 'X-Requested-With':'XMLHttpRequest' }, credentials: 'same-origin' });
      if(!res.ok) throw new Error(res.status);
      let result = await res.text();
      let parser = new DOMParser();
      result = parser.parseFromString(result, 'text/html').querySelector('.shopify-section').innerHTML;
      wrap.insertAdjacentHTML('beforeend', result);
      wrap.dataset.comparisonPopupState = 'loaded';
      document.querySelector('.loading-overlay').classList.remove('active');
    }catch(e){
      console.error('comparison load',e);
    }finally{
      btn?.removeAttribute('aria-busy');
    }
    calpak.Popupopen();
    calpak.setMaxHeightToPTags();
    skeletonLoader(wrap);
  }

  function attach(){
    document.querySelectorAll('.js-compare-button').forEach(btn=>{
      if(btn.dataset.compareAttached) return;
      btn.addEventListener('click', e => { e.preventDefault(); loadComparison(btn); });
      btn.dataset.compareAttached = '1';
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach); else attach();
  document.addEventListener('calpak:loaded', attach);
})();


// Custom Element to load "Complete Your Set" upsell section
class PdpCompleteYourSetUpsell extends HTMLElement {
    connectedCallback() {
        let productUrl = this.dataset.url;
        if (!productUrl) return;
        if (this.dataset.pdyLoadState) return; // prevent double load
        this.dataset.pdyLoadState = 'loading';
        (async () => {
            try {
                const url = productUrl + (productUrl.includes('?') ? '&' : '?') + 'section_id=pdp-complete-your-set-upsell';
                const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
                if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
                const text = await res.text();
                const doc = new DOMParser().parseFromString(text, 'text/html');
                const section = doc.querySelector('.shopify-section');
                if (!section) throw new Error('No .shopify-section found in response');
                // Replace this custom element with the fetched section HTML
                const newNode = section.cloneNode(true);
                this.replaceWith(newNode);
                document.dispatchEvent(new CustomEvent('pdp-complete-your-set-upsell:loaded', { detail: { url: productUrl, node: newNode } }));
                window.initAttentiveSwatchEvents();
            } catch (err) {
                console.error('pdp-complete-your-set-upsell load error', err);
                delete this.dataset.pdyLoadState;
            }
        })();
    }
}

customElements.define('pdp-complete-your-set-upsell', PdpCompleteYourSetUpsell);